/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { addCart } from "../../redux/slices/Cart";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Button } from "bootstrap";
import ShareSocialModal from "../ShareSocialModal";
import { FaRegShareSquare } from "react-icons/fa";
import { axiosInstance } from "../utils/axiosInstance";
import { imgUrl } from "../utils/imgUrl";

const SingleProduct = ({
  productData,
  handleShow,
  handleClose,
  showModal,
  urlToShare,
}) => {
  const cart = useSelector((state) => state?.cart?.cart);
  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState({});
  useEffect(() => {
    setSelectedSize(cart?.size ? cart?.size : productData?.sizes[0]?.name);
  }, []);

  const dispatch = useDispatch();

  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const handleIngredientChange = (ingredient, subIngredient) => {
    setSelectedIngredients((prev) => {
      const exists = prev.some(
        (item) =>
          item.categoryId === ingredient?.ingredient_category?.id &&
          item.subIngredient?.name === subIngredient?.name
      );

      if (exists) {
        return prev.filter(
          (item) =>
            item.categoryId !== ingredient?.ingredient_category?.id ||
            item.subIngredient?.name !== subIngredient?.name
        );
      } else {
        return [
          ...prev,
          {
            categoryId: ingredient?.ingredient_category?.id,
            categoryName: ingredient?.ingredient_category?.name,
            subIngredient,
          },
        ];
      }
    });
  };

  const addWishlist = async (id) => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);
      const response = await axiosInstance.post("user/whishlist", formData);
      if (response?.data?.status === true) {
        toast.success(
          response?.data?.message ||
            "This Product Has Been Added In Your Favourite"
        );
      } else {
        toast.error(
          response?.data?.message || "Something went wrong, try again."
        );
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error?.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    }
  };

  return (
    <div className="row">
      <div
        className="col-lg-5 col-sm-10 col-md-9 wow fadeInUp"
        data-wow-duration="1s"
      >
        <div className="exzoom hidden h-100" id="exzoom">
          <Swiper
            style={{
              "--swiper-navigation-color": "#fff",
              "--swiper-pagination-color": "#fff",
            }}
            zoom={true}
            navigation={true}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation]}
            breakpoints={{
              640: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
            }}
            className="productDatalider h-100"
          >
            {productData?.images?.map((e, i) => (
              <SwiperSlide>
                <div className="swiper-zoom-container h-100">
                  <img
                    className="zoom ing-fluid w-100 h-100"
                    src={imgUrl + e?.name}
                    alt="product"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
      <div className="col-lg-7 wow fadeInUp" data-wow-duration="1s">
        <div className="menu_details_text">
          <h2>{productData?.name}</h2>
          {productData?.discount_status === 1 ? (
            <>
              <p
                className="font-20 fw-bold pt-1 text-white bg-danger px-2 rounded"
                style={{ width: "fit-content" }}
              >
                {productData?.discount_percent}% Off
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "start",
                }}
              >
                <h3 className="price">$ {productData?.sizes[0].price}</h3>
                <h3
                  className="price"
                  style={{ textDecoration: "line-through", color: "red" }}
                >
                  $ {productData?.sizes[0].sub_price}
                </h3>
              </div>
            </>
          ) : (
            <h3 className="price">$ {productData?.sizes[0].price}</h3>
          )}

          <p className="short_description">{productData?.description}</p>
          {/* <div className="details_size">
            <h5>select size</h5>
            {productData?.sizes?.map((size, i) => {
              return (
                <div className="form-check" key={i}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="size"
                    id={`size-${i}`}
                    defaultChecked={
                      size?.name === selectedSize?.name && "check"
                    }
                    onChange={() => setSelectedSize(size)}
                  />
                  <label className="form-check-label" htmlFor={`size-${i}`}>
                    {size?.name} <span>+ {size?.price}</span>
                  </label>
                </div>
              );
            })}
          </div> */}

          <div className="details_size">
            {productData?.product_ingredient_descriptions?.length > 0 && (
              <>
                <h5>Seasoning</h5>
                {productData?.product_ingredient_descriptions?.map(
                  (ingredient, index) => (
                    <div key={index}>
                      <span className="py-2 ">{ingredient?.description}</span>
                    </div>
                  )
                )}
              </>
            )}
          </div>

          <div className="details_size">
            {productData?.product_ingredient_categories?.map(
              (ingredient, index) => (
                <div key={index}>
                  <h5>{ingredient?.ingredient_category?.name}</h5>
                  {ingredient?.subcategories?.map((subIngredient, i) => (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name={`ingredient-${ingredient?.ingredient_category?.id}`}
                        id={`ingredient-${index}-${i}`}
                        checked={selectedIngredients.some(
                          (item) =>
                            item.categoryId ===
                              ingredient?.ingredient_category?.id &&
                            item.subIngredient?.name === subIngredient?.name
                        )}
                        onChange={() =>
                          handleIngredientChange(ingredient, subIngredient)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`ingredient-${index}-${i}`}
                      >
                        {subIngredient?.name}
                      </label>
                    </div>
                  ))}
                </div>
              )
            )}
          </div>

          <div className="details_quentity">
            <h5>
              {productData?.category?.name === "Drinks"
                ? "Select Quantity"
                : "Select Per Lbs"}
            </h5>
            <div className="quentity_btn_area d-flex flex-wrapa align-items-center">
              <div className="quentity_btn">
                <button
                  onClick={
                    quantity === 1 ? null : () => setQuantity(quantity - 1)
                  }
                  className="btn btn-danger"
                >
                  <i className="fal fa-minus" />
                </button>
                <input type="text" value={quantity} disabled placeholder={1} />
                <button
                  onClick={() => setQuantity(quantity + 1)}
                  className="btn btn-success"
                >
                  <i className="fal fa-plus" />
                </button>
              </div>
              <h3>
                $
                {selectedSize?.price
                  ? selectedSize?.price * quantity
                  : productData?.sizes[0]?.price * quantity}
              </h3>
            </div>
          </div>
          <ul className="details_button_area d-flex flex-wrap">
            <li>
              <button
                onClick={() => {
                  toast.success("Cart Added Successfully");
                  const existingProductIndex = cart?.findIndex(
                    (item) =>
                      item?.id === productData?.id &&
                      item?.size ===
                        (selectedSize?.name || productData?.sizes[0].name)
                  );
                  if (existingProductIndex !== -1) {
                    const updatedCart = cart.map((item, index) => {
                      return index === existingProductIndex
                        ? {
                            ...item,
                            quantity: item?.quantity + quantity,
                            product_ingredient_categories: selectedIngredients
                              ? selectedIngredients
                              : [],
                          }
                        : item;
                    });

                    dispatch(addCart(updatedCart));
                  } else {
                    dispatch(
                      addCart([
                        ...cart,
                        {
                          ...productData,
                          quantity: quantity,
                          size:
                            selectedSize?.name || productData?.sizes[0]?.name,
                          price:
                            selectedSize?.price || productData?.sizes[0]?.price,
                          product_ingredient_categories:
                            selectedIngredients || [],
                        },
                      ])
                    );
                  }
                }}
                className="common_btn"
              >
                add to cart
              </button>
            </li>
            <li>
              <button
                className="common_btn"
                onClick={() => addWishlist(productData?.id)}
              >
                Favourite
              </button>
            </li>
            <li>
              <button
                className="common_btn ms-3"
                style={{ width: "fit-content" }}
                onClick={handleShow}
              >
                <FaRegShareSquare size={25} />
              </button>
            </li>
          </ul>
          <div className="App">
            {/* Modal Component */}
            <ShareSocialModal
              showModal={showModal}
              handleClose={handleClose}
              url={urlToShare}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default SingleProduct;
